
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/volantini-digitali/[categoriaSlug]/[slug]",
      function () {
        return require("private-next-pages/volantini-digitali/[categoriaSlug]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/volantini-digitali/[categoriaSlug]/[slug]"])
      });
    }
  